<button mat-raised-button color="{{ color }}" [ngClass]="styleClass" [disabled]="disabled" *ngIf="text !== undefined">
  <i *ngIf="icon" class="{{ icon }}"></i>
  {{ text }}
</button>
<button mat-raised-button *ngIf="!text && icon !== undefined" color="{{ color }}" [ngClass]="styleClass" [disabled]="disabled">
  <i class="{{ icon }}"></i>
</button>

